import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import axios from 'src/api/Api';
import {
    GET_SHIP_TO_ADDRESS_SUCCESS,
    GET_SHIP_TO_ADDRESS_FAILURE,
} from '../actions';

export default function* getShipToAddress(action) { 
    const searchParams = action.payload??'';
    // const addressAcountId = yield select(
    //     (state) => state.consignmentReducer.surgeryDetails.accountId.accountId
    // );

    const billToShipToPartnerRole = localStorage.getItem('billToShipToPartnerRole');
    const sapPartnerIdOtherUser =  yield select(
       (state) => state.consignmentReducer.surgeryDetails.accountId.accountId
       );
    const sapPartnerIdJapanUser = yield select(
         (state) => state.consignmentReducer.surgeryDetails?.billToId?.billToNumber
     );
     const sapPartnerIdResult = function (){
         if(billToShipToPartnerRole == 'BILL_TO'){
             return sapPartnerIdJapanUser;
         }
         else 
         return sapPartnerIdOtherUser;     
     };
    const addressAcountId = sapPartnerIdResult();


    // const selAcc = addressAcountId["[object Object]"].accountId

    // const url = `occ/v2/${localStorage.getItem(
    //     'baseSiteId'
    // )}/order/surgery/shiptoaddress?sapPartnerId=${selectedAccount.selectedAccount!==undefined ? selectedAccount.selectedAccount.accountId :sapPartnerId}`;
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/shiptoaddress?sapPartnerId=${encodeURIComponent(addressAcountId)}&orderType=KE&searchTerm=${encodeURIComponent(searchParams)}`;
    //debugger
    try {
        const result = yield axios.get(url).then((response) => response.data);
        const updatedResult =  { ...result,
            shipToData: {
                ...result.shipToData,
                nonTissueAddress: result.shipToData?.nonTissueAddress?.map((item) => {
                    const shippingAddress = `${item.accountName} ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                    item.formattedShippingAddressId = shippingAddress;
                    return item;
                }),
                tissueAddress: result.shipToData?.tissueAddress?.map((item)=>{
                    const shippingAddress = `${item.accountName} ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                    item.formattedShippingAddressId = shippingAddress;
                    return item;
                })
            },
        }; 
        yield put({
            type: GET_SHIP_TO_ADDRESS_SUCCESS,
            payload: updatedResult.shipToData || [],
            statusCode: updatedResult.statusCode,
            statusMessage: updatedResult.statusMessage,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_SHIP_TO_ADDRESS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
